import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, Output } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { SurveyOptionDto } from '../../../shared/types/survey-dto';

@Component({
  selector: 'lp2-live-class-survey-image-selector',
  templateUrl: './live-class-survey-image-selector.component.html',
  styleUrls: ['./live-class-survey-image-selector.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    { provide: NG_VALUE_ACCESSOR, useExisting: LiveClassSurveyImageSelectorComponent, multi: true }
  ]
})
export class LiveClassSurveyImageSelectorComponent {
  @Input() public options: SurveyOptionDto[];
  @Input() public imgPath: string;
  @Input() public value: SurveyOptionDto;
  @Input() public isDisabled = false;

  @Output() public valueChanges = new EventEmitter<SurveyOptionDto>();

  constructor(private readonly cdRef: ChangeDetectorRef) {}

  public setValue(option: SurveyOptionDto) {
    this.value = option;
    this.valueChanges.emit(option);
    this.cdRef.detectChanges();
  }

  public isSelected(option: SurveyOptionDto) {
    return this.value && option.questionOption === this.value.questionOption;
  }

}



// WEBPACK FOOTER //
// ./ts/app/shared/live-class-survey/live-class-survey-image-selector/live-class-survey-image-selector.component.ts